// TypeEntreprise.tsx
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  register: any;
  watch: any;
  setValue: any;
};

const cacOptions = [
  {
    id: "CAC2",
    label:
      "Association cultuelle ou établissement public des cultes reconnus d’Alsace-Moselle",
  },
  {
    id: "CAC3",
    label:
      "Établissement d’enseignement supérieur ou d’enseignement artistique public ou privé, d’intérêt général à but non lucratif",
  },
  {
    id: "CAC4",
    label:
      "Établissement d’enseignement supérieur consulaire mentionné à l'article L. 711-17 du code de commerce",
  },
  {
    id: "CAC5",
    label:
      "Société ou organisme public ou privé agréé par le ministre chargé du budget en vertu de l’article 4 de l'ordonnance n° 58-882 du 25 septembre 1958 relative à la fiscalité en matière de recherche scientifique et technique",
  },
  {
    id: "CAC6",
    label:
      "Organisme public ou privé dont la gestion est désintéressée et qui a pour activité principale la présentation au public d'œuvres dramatiques, lyriques, musicales, chorégraphiques, cinématographiques, audiovisuelles et de cirque ou l'organisation d'expositions d'art contemporain",
  },
  {
    id: "CAC7",
    label:
      "Projet de thèse proposé au mécénat de doctorat par une école doctorale",
  },
  {
    id: "CAC8",
    label:
      "Société, dont l’État est l'actionnaire unique, qui a pour activité la représentation de la France aux expositions universelles",
  },
  {
    id: "CAC9",
    label:
      "Société nationale de programme mentionnée à l’article 44 de la loi n° 86-1067 du 30 septembre 1986 relative à la liberté de communication et affectés au financement de programmes audiovisuels culturels",
  },
  {
    id: "CAC10",
    label:
      "Société nationale de programme mentionnée au III de l'article 44 de la loi n° 86-1067 du 30 septembre 1986 relative à la liberté de communication et affectés au financement des activités des formations musicales dont elle assure la gestion et le développement",
  },
  {
    id: "CAC11",
    label:
      "Fondation du patrimoine ou fondation ou association reconnue d’utilité publique qui subventionnent des travaux sur des monuments historiques dans le cadre des conventions prévues à l’article L.143-2-1 et L. 143-15 du code du patrimoine",
  },
  { id: "CAC12", label: "Fonds de dotation" },
  {
    id: "CAC13",
    label:
      "Organisme agréé ayant pour objet exclusif d’accorder des aides financières ou de fournir des prestations d’accompagnement à des petites et moyennes entreprises (4 de l’article 238 bis du CGI)",
  },
  {
    id: "CAC14",
    label:
      "Fédération ou union d’organismes ayant pour objet exclusif de fédérer, d’organiser, de représenter et de promouvoir les organismes agréés en application du 4 de l’article 238 bis du code général des impôts ",
  },
  {
    id: "CAC15",
    label:
      "Organismes ayant pour objet la sauvegarde, contre les effets d’un conflit armé, des biens culturels mentionnés à l'article 1er de la Convention du 14 mai 1954 pour la protection des biens culturels en cas de conflit armé (5 de l’article 238 bis du CGI)",
  },
  {
    id: "CAC16",
    label:
      "Organisme établi dans un État membre de l’Union européenne autre que la France poursuivant des objectifs et présentant des caractéristiques similaires aux organismes précités",
  },
  { id: "NCERFA", label: "Mon entreprise ne délivre pas de CERFA." },
];

const subOptions = [
  { value: "1", label: "Association loi 1901" },
  {
    value: "2",
    label:
      "Association ou fondation reconnue d’utilité publique ou association située dans le département de la Moselle, du Bas-Rhin",
  },
  {
    value: "3",
    label:
      "Fondation universitaire ou fondation partenariale mentionnées respectivement aux articles L.719-12 et L.719-13 du code de l’éducation",
  },
  { value: "4", label: "Fondation d’entreprise" },
  { value: "5", label: "Musée de France" },
  {
    value: "6",
    label:
      "Organismes sans but lucratif fournissant gratuitement une aide alimentaire, des soins médicaux ou produits de première nécessité",
  },
];

const cacOptionsEn = [
  {
    id: "CAC2",
    label:
      "Religious association or public institution of recognized religions in Alsace-Moselle",
  },
  {
    id: "CAC3",
    label:
      "Public or private higher education or artistic education institution of general interest, non-profit",
  },
  {
    id: "CAC4",
    label:
      "Consular higher education institution referred to in Article L. 711-17 of the French Commercial Code",
  },
  {
    id: "CAC5",
    label:
      "Public or private company or organization approved by the minister in charge of the budget under Article 4 of Ordinance No. 58-882 of 25 September 1958 relating to taxation in the field of scientific and technical research",
  },
  {
    id: "CAC6",
    label:
      "Public or private organization with non-profit management whose main activity is presenting dramatic, lyrical, musical, choreographic, cinematographic, audiovisual, or circus works to the public, or organizing contemporary art exhibitions",
  },
  {
    id: "CAC7",
    label:
      "Doctoral thesis project proposed for doctoral sponsorship by a doctoral school",
  },
  {
    id: "CAC8",
    label:
      "Company wholly owned by the State whose activity is representing France at world exhibitions",
  },
  {
    id: "CAC9",
    label:
      "National program company referred to in Article 44 of Law No. 86-1067 of 30 September 1986 relating to freedom of communication, financing cultural audiovisual programs",
  },
  {
    id: "CAC10",
    label:
      "National program company referred to in III of Article 44 of Law No. 86-1067 of 30 September 1986 relating to freedom of communication, financing activities of musical groups it manages and develops",
  },
  {
    id: "CAC11",
    label:
      "Heritage foundation or public utility foundation or association subsidizing work on historical monuments under the conventions provided in Articles L.143-2-1 and L.143-15 of the Heritage Code",
  },
  { id: "CAC12", label: "Endowment fund" },
  {
    id: "CAC13",
    label:
      "Approved organization exclusively granting financial aid or providing support services to small and medium-sized enterprises (Article 238 bis, 4° of the French Tax Code)",
  },
  {
    id: "CAC14",
    label:
      "Federation or union of organizations exclusively aimed at federating, organizing, representing, and promoting approved organizations under Article 238 bis, 4° of the French Tax Code",
  },
  {
    id: "CAC15",
    label:
      "Organizations aimed at protecting cultural property referred to in Article 1 of the 14 May 1954 Convention for the Protection of Cultural Property in the Event of Armed Conflict (Article 238 bis, 5° of the French Tax Code)",
  },
  {
    id: "CAC16",
    label:
      "Organization established in a European Union member state other than France pursuing similar objectives and characteristics as the above-mentioned organizations",
  },
  {
    id: "NCERFA",
    label:
      "My company does not issue official French administrative forms (CERFA).",
  },
];

const subOptionsEn = [
  { value: "1", label: "Association under the 1901 Law" },
  {
    value: "2",
    label:
      "Association or foundation recognized as being of public utility, or an association located in the Moselle or Bas-Rhin departments",
  },
  {
    value: "3",
    label:
      "University foundation or partnership foundation referred to in Articles L.719-12 and L.719-13 of the Education Code, respectively",
  },
  { value: "4", label: "Corporate foundation" },
  { value: "5", label: "Museum of France" },
  {
    value: "6",
    label:
      "Non-profit organizations providing free food aid, medical care, or essential products",
  },
];

export default function TypeEntreprise({ register, watch, setValue }: Props) {
  const { i18n } = useTranslation();

  const options = i18n.language === "en" ? cacOptionsEn : cacOptions;
  const subOpt = i18n.language === "en" ? subOptionsEn : subOptions;

  const checkedCACs: string[] = watch("cacs", []) || [];
  const selectedSub: string = watch("cac1Sub", "");
  const isCAC1Checked = checkedCACs.includes("CAC1");

  // 👉 Nouveau : switch ONG (par défaut true)
  const isONG: boolean | undefined = watch("isONG");

  // Synchronisation logique :
  // - Quand isONG = true : forcer cacs = ["NCERFA"] et vider cac1Sub
  // - Quand isONG = false : retirer NCERFA des cacs (sans toucher aux autres)
  useEffect(() => {
    // Si isONG est déjà défini (user ou defaultValues), ne rien faire
    if (typeof isONG !== "undefined") return;

    const onlyNCERFA =
      checkedCACs.length === 1 && checkedCACs.includes("NCERFA");

    // Règles :
    // - Edition avec valeurs : NCERFA seul => entreprise, sinon => asso
    // - Création sans valeurs (cacs vide) : par défaut entreprise
    const derived = checkedCACs.length === 0 ? true : onlyNCERFA;

    setValue("isONG", derived, { shouldDirty: false, shouldTouch: false });

    // En cas d'entreprise, on normalise aussi cacs/cac1Sub proprement
    if (derived) {
      setValue("cacs", ["NCERFA"], { shouldDirty: false, shouldTouch: false });
      setValue("cac1Sub", "", { shouldDirty: false, shouldTouch: false });
    }
    // sinon, ton useEffect existant gèrera l'affichage formulaire + retrait de NCERFA
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isONG, checkedCACs]);

  // Quand le switch est décoché, on doit cacher l'option NCERFA
  const visibleOptions = isONG
    ? [] // on cache tout quand ONG
    : options.filter((opt) => opt.id !== "NCERFA");

  return (
    <div className="space-y-4">
      {/* Radios Entreprise vs ASSO (remplace le switch) */}
      <div className="space-y-2">
        {/* <span className="font-medium text-gray-700">
          {i18n.language === "en" ? "Select organization type" : "Sélection du type d’organisation"}
        </span> */}

        {/* Radios Entreprise vs ASSO - version harmonisée en vert #1d5214 */}
        <fieldset className="space-y-3">
          <legend className="font-semibold text-gray-800">
            {i18n.language === "en"
              ? "Select organization type"
              : "Sélection du type d’organisation"}
          </legend>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Carte ENTREPRISE */}
            <label
              className={`relative cursor-pointer rounded-2xl border p-5 transition-all
              ${
                isONG
                  ? "border-[#1d5214] ring-4 ring-[#e6f0ea] shadow-lg"
                  : "border-gray-200 hover:border-gray-300 hover:shadow-md"
              }
              bg-white`}
            >
              <div className="flex items-start gap-4">
                <input
                  type="radio"
                  name="orgType"
                  className="sr-only"
                  checked={isONG === true}
                  onChange={() => {
                    setValue("isONG", true, {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                    // Normalisation immédiate : NCERFA seul
                    setValue("cacs", ["NCERFA"], {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                    setValue("cac1Sub", "", {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                  }}
                  aria-label={
                    i18n.language === "en"
                      ? "I am a company"
                      : "Je suis une entreprise"
                  }
                />

                {/* Icône */}
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-xl transition-colors
                ${
                  isONG
                    ? "bg-[#1d5214] text-white"
                    : "bg-gray-100 text-gray-600"
                }`}
                >
                  {/* building icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3 21h18v-2H3v2zm2-4h2v-2H5v2zm0-4h2V9H5v4zm0-6h2V5H5v2zm4 10h2v-2H9v2zm0-4h2V9H9v4zm0-6h2V5H9v2zm4 10h2v-2h-2v2zm0-4h2V9h-2v4zm0-6h2V5h-2v2zm4 10h2V3h-6v14h4z" />
                  </svg>
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="text-lg font-semibold">
                      {i18n.language === "en"
                        ? "I am a company"
                        : "Je suis une entreprise"}
                    </h3>
                    {/* {isONG && (
                    <span className="rounded-full bg-[#e6f0ea] px-2 py-0.5 text-xs font-medium text-[#1d5214]">
                      {i18n.language === "en" ? "Selected" : "Sélectionné"}
                    </span>
                  )} */}
                  </div>
                  <p className="mt-1 text-sm text-gray-600">
                    {i18n.language === "en"
                      ? "My company does not issue official French administrative forms (CERFA)."
                      : "Mon entreprise ne délivre pas de CERFA."}
                  </p>
                </div>
              </div>

              {/* Pastille sélection */}
              <span
                className={`pointer-events-none absolute top-4 right-4 inline-flex h-5 w-5 items-center justify-center rounded-full border-2
                ${isONG ? "border-[#1d5214]" : "border-gray-300"}`}
                aria-hidden="true"
              >
                <span
                  className={`h-3 w-3 rounded-full transition ${
                    isONG ? "bg-[#1d5214]" : "bg-transparent"
                  }`}
                />
              </span>
            </label>

            {/* Carte ASSO */}
            <label
              className={`relative cursor-pointer rounded-2xl border p-5 transition-all
              ${
                !isONG
                  ? "border-[#1d5214] ring-4 ring-[#e6f0ea] shadow-lg"
                  : "border-gray-200 hover:border-gray-300 hover:shadow-md"
              }
              bg-white`}
            >
              <div className="flex items-start gap-4">
                <input
                  type="radio"
                  name="orgType"
                  className="sr-only"
                  checked={isONG === false}
                  onChange={() => {
                    setValue("isONG", false, {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                    // Retirer NCERFA, conserver le reste
                    const current = watch("cacs", []) || [];
                    const cleaned = current.filter(
                      (c: string) => c !== "NCERFA"
                    );
                    setValue("cacs", cleaned, {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                  }}
                  aria-label={
                    i18n.language === "en"
                      ? "I am an association"
                      : "Je suis une ASSO"
                  }
                />

                {/* Icône */}
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-xl transition-colors
                ${
                  !isONG
                    ? "bg-[#1d5214] text-white"
                    : "bg-gray-100 text-gray-600"
                }`}
                >
                  {/* users icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5c0-2.33-4.67-3.5-7-3.5z" />
                  </svg>
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="text-lg font-semibold">
                      {i18n.language === "en"
                        ? "I am an association"
                        : "Je suis une ASSO"}
                    </h3>
                    {/* {!isONG && (
                    <span className="rounded-full bg-[#e6f0ea] px-2 py-0.5 text-xs font-medium text-[#1d5214]">
                      {i18n.language === "en" ? "Selected" : "Sélectionné"}
                    </span>
                  )} */}
                  </div>
                  <p className="mt-1 text-sm text-gray-600">
                    {i18n.language === "en"
                      ? "My association issues a CERFA (form to fill in below)"
                      : "Mon association délivre un CERFA (formulaire à remplir ci-dessous)."}
                  </p>
                </div>
              </div>

              {/* Pastille sélection */}
              <span
                className={`pointer-events-none absolute top-4 right-4 inline-flex h-5 w-5 items-center justify-center rounded-full border-2
                ${!isONG ? "border-[#1d5214]" : "border-gray-300"}`}
                aria-hidden="true"
              >
                <span
                  className={`h-3 w-3 rounded-full transition ${
                    !isONG ? "bg-[#1d5214]" : "bg-transparent"
                  }`}
                />
              </span>
            </label>
          </div>

          {/* Helper text */}
          <p className="text-xs text-gray-500">
            {i18n.language === "en"
              ? "You can change this at any time. Your selection updates the rest of the form automatically."
              : "Vous pouvez changer ce choix à tout moment. Votre sélection met à jour le reste du formulaire automatiquement."}
          </p>
        </fieldset>
      </div>
      <br></br>

      {/* Si ONG => on cache tout le reste */}
      {!isONG && (
        <div className="pl-3">
          {/* Checkbox CAC1 (parent) */}
          <label className="flex items-start gap-2">
            <input
              type="checkbox"
              value="CAC1"
              {...register("cacs")}
              checked={checkedCACs.includes("CAC1")}
              onChange={(e) => {
                const newValue = e.target.checked
                  ? [...checkedCACs, "CAC1"]
                  : checkedCACs.filter((c: string) => c !== "CAC1");

                setValue("cacs", Array.from(new Set(newValue)));
                if (!e.target.checked) {
                  setValue("cac1Sub", ""); // reset radio if parent uncheck
                }
              }}
            />
            <span>
              {i18n.language === "en"
                ? "Organization of general interest"
                : "Organisme d’intérêt général"}
            </span>
          </label>

          {/* Radios si CAC1 coché */}
          {isCAC1Checked && (
            <div className="space-y-2 pl-6">
              {subOpt.map((opt) => (
                <label key={opt.value} className="flex items-start gap-2">
                  <input
                    type="radio"
                    value={opt.value}
                    {...register("cac1Sub")}
                    checked={selectedSub === opt.value}
                    onChange={() => setValue("cac1Sub", opt.value)}
                  />
                  <span>{opt.label}</span>
                </label>
              ))}
            </div>
          )}

          {/* Autres CAC (hors NCERFA) */}
          {visibleOptions.map((opt) => (
            <label key={opt.id} className="flex items-start gap-2">
              <input
                type="checkbox"
                value={opt.id}
                {...register("cacs")}
                checked={checkedCACs.includes(opt.id)}
                onChange={(e) => {
                  const newValue = e.target.checked
                    ? [...checkedCACs, opt.id]
                    : checkedCACs.filter((c: string) => c !== opt.id);
                  setValue("cacs", Array.from(new Set(newValue)));
                }}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
